import { updateCustomerData } from "../../../services/api/onboarding/customer";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_CUSTOMER_ENTITY } from "../queries/useQueryCustomerEntity";

export const useMutationUpdateCustomerData = () =>
  useWSMutation<
    Awaited<ReturnType<typeof updateCustomerData>>,
    WSServiceError,
    {
      relationshipType: Parameters<typeof updateCustomerData>[0];
      requestData: Parameters<typeof updateCustomerData>[1];
    }
  >(
    ({ relationshipType, requestData }) =>
      updateCustomerData(relationshipType, requestData),
    {
      dependencies: [QUERY_CUSTOMER_ENTITY]
    }
  );
